import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { createForms } from 'react-redux-form';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { Kirks, InitialKirk } from './kirks';
import { Inputs, InitialInput } from './inputs';
import { ProInputs, InitialProInput } from './proInputs';
import { FieldButtons, InitialFieldButtons } from './fieldButtons';
import { Auth } from './auth';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

// Middleware to force immediate persistence
const persistenceMiddleware = store => next => action => {
  const result = next(action);

  // If action affects fieldButtons, save immediately
  if (
    action.type &&
    (action.type.includes('TOGGLE') || action.type.includes('SET_IS'))
  ) {
    const state = store.getState();
    const fieldButtonsState = state.fieldButtons;
    try {
      localStorage.setItem(
        'persist:root',
        JSON.stringify({
          fieldButtons: JSON.stringify(fieldButtonsState),
          _persist: JSON.stringify({ version: -1, rehydrated: true })
        })
      );
      console.log('✅ Immediately saved fieldButtons to localStorage');
    } catch (err) {
      console.error('Manual persist failed:', err);
    }
  }

  return result;
};

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['fieldButtons'],
  throttle: 0 // Save immediately, no throttling
};

export const ConfigureStore = () => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const rootReducer = combineReducers({
    kirks: Kirks,
    auth: Auth,
    inputs: Inputs,
    proInputs: ProInputs,
    fieldButtons: FieldButtons,
    ...createForms({
      kirk: InitialKirk,
      input: InitialInput,
      proInput: InitialProInput
    })
  });

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(thunk, persistenceMiddleware, logger))
  );

  const persistor = persistStore(store);

  return { store, persistor };
};
